<template>
  <wd-config-provider :themeVars="themeVars" :locale="wdLocale" :key="locale">
    <slot />
    <wd-toast />
    <wd-message-box />
  </wd-config-provider>
</template>

<script lang="ts" setup>
import type { ConfigProviderThemeVars } from 'wot-design-uni'
import enUS from 'wot-design-uni/locale/lang/en-US'
import zhCN from 'wot-design-uni/locale/lang/zh-CN'

const { locale } = useI18n()

const wdLocale = computed(() => {
  const currentLocale = locale.value === 'zh-CN' ? zhCN : enUS
  console.log('[wot-design-uni] Locale changed to:', locale.value, currentLocale)
  return currentLocale
})

const themeVars: ConfigProviderThemeVars = {
  // colorTheme: 'red',
  // buttonPrimaryBgColor: '#07c160',
  // buttonPrimaryColor: '#07c160',
}
</script>
